import { useState, memo } from "react";
import { Row, Col, Card, CardHeader, CardBody, Collapse, Label } from "reactstrap";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import UserUtils from "src/services/utils/UserUtils";

const CONTACT_FIELDS = [
	{ key: "title", label: "Salutation" },
	{ key: "email", label: "Email" },
	{ key: "phone", label: "Phone" },
	{ key: "name", label: "Name" },
	{ key: "position", label: "Position" },
	{ key: "company", label: "Company" },
	{ key: "organization", label: "Organization" },
	{ key: "roles", label: "Role" },
	{ key: "relation_company", label: "Relation company" },
];

const userUtils = new UserUtils();

const formatValue = (key, value, t) => {
	if (key === "roles") {
		if (!Array.isArray(value) || !value.length) {
			return null;
		}
		const topRole = userUtils.getUserTopRole(value);
		const roleLabel = userUtils.gerUserRole(topRole);
		return roleLabel ? t(roleLabel) : null;
	}

	if (value === null || value === undefined || value === "") {
		return null;
	}

	if (Array.isArray(value)) {
		const joined = value.filter(Boolean).join(", ");
		return joined || null;
	}

	if (typeof value === "object") {
		return value.title || value.name || null;
	}

	return String(value);
};

const ReportContactDetails = function (props) {
	const [isOpen, setIsOpen] = useState(true);
	const ownerInfo = props.ownerInfo || {};
	const excludedFields = props.excludedFields || [];

	const fields = CONTACT_FIELDS
		.filter(({ key }) => !excludedFields.includes(key))
		.map(({ key, label }) => ({
			key,
			label,
			value: formatValue(key, ownerInfo[key], props.t),
		}))
		.filter((field) => field.value);

	return (
		<Row>
			<Col sm="12">
				<Card className="mb-1 shadow-none">
					<Link
						to="#"
						onClick={() => {
							setIsOpen(!isOpen);
						}}
						style={{ cursor: "pointer" }}
						className="text-dark"
					>
						<CardHeader id="headingContactDetails" className="org-primary-header">
							<h6 className="m-0 font-14">
								{props.t("Contact details")}
								<i
									className={`float-end accor-plus-icon mdi ${
										isOpen ? "mdi-minus" : "mdi-plus"
									}`}
								></i>
							</h6>
						</CardHeader>
					</Link>

					<Collapse isOpen={isOpen}>
						<CardBody style={{ paddingLeft: "2px" }}>
							{fields.map((field) => (
								<Row key={field.key}>
									<Col sm="12" lg="12">
										<div className="mb-3">
											<Label className="form-check-label mb-1">
												{props.t(field.label)}
											</Label>
											<div
												className="text-answers"
												style={{
													margin: 0,
												}}
											>
												<span>{field.value}</span>
											</div>
										</div>
									</Col>
								</Row>
							))}
						</CardBody>
					</Collapse>
				</Card>
			</Col>
		</Row>
	);
};

export default withNamespaces()(memo(ReportContactDetails));
